<template>
  <div id="app">
    <Events
      :api="api"
      :loading="loading"
      @enable-loading="enableLoading"
      @disable-loading="disableLoading">
    </Events>
  </div>
</template>

<script>
  import Events from "./components/Events.vue";

  export default {
    components: {
      Events
    },

    data() {
      return {
        api: "https://master-7rqtwti-blb5cbodtjgb6.us.platform.sh",
        loading: true,
      }
    },

    methods: {
      enableLoading() {
        this.loading = true;
      },

      disableLoading() {
        this.loading = false;
      }
    }
  }
</script>

<style>

  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 2vw;
  }

  body {
    color: #121212;
    margin: 0;
    padding: 0;
  }

  .fade {
    backface-visibility: hidden;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  @media all and (min-width: 60em) {
    html {
      font-size: 1vw;
      margin: 0 auto;
      max-width: 1024px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/App.vue